import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, KeyRound, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function SchoolForgotPassword() {
  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSaving(true);
    try {
      await api.post("/auth/school-forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao enviar. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl p-8 card-shadow">
          <div className="flex flex-col items-center text-center mb-6">
            <div className="w-16 h-16 rounded-2xl bg-[#1e3a8a] flex items-center justify-center mb-3">
              <KeyRound className="w-8 h-8 text-white" strokeWidth={2.2} />
            </div>
            <h1 className="font-heading text-2xl font-black text-[#1e3a8a]">Esqueci minha senha</h1>
            <p className="text-sm text-slate-500 mt-1 max-w-xs">
              Informe o e-mail cadastrado e enviaremos um link para você criar uma nova senha.
            </p>
          </div>

          {sent ? (
            <div
              className="rounded-2xl border border-green-200 bg-green-50 p-4 text-center"
              data-testid="forgot-sent-banner"
            >
              <CheckCircle2 className="w-10 h-10 text-green-600 mx-auto mb-2" />
              <p className="font-heading text-base font-bold text-green-900 mb-1">
                Verifique seu e-mail
              </p>
              <p className="text-sm text-green-800 leading-snug">
                Se o endereço estiver cadastrado, você receberá em instantes um link válido por{" "}
                <strong>1 hora</strong> para redefinir a senha.
              </p>
              <p className="text-xs text-green-700 mt-3">
                Não achou? Confira a caixa de <strong>spam/lixo eletrônico</strong>.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <label className="block text-xs font-semibold text-slate-700 mb-1.5">E-mail</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email"
                    required
                    autoFocus
                    className="w-full h-11 pl-9 pr-3 rounded-xl border border-slate-200 bg-slate-50 text-sm focus:outline-none focus:ring-2 focus:ring-[#7c3aed] focus:border-transparent"
                    placeholder="voce@escola.com"
                  />
                </div>
              </div>
              <Button
                type="submit"
                disabled={saving}
                className="w-full h-11 bg-[#7c3aed] hover:bg-[#6d28d9] text-white rounded-xl font-semibold"
                data-testid="forgot-submit"
              >
                {saving ? "Enviando..." : "Enviar link de redefinição"}
              </Button>
            </form>
          )}

          <div className="mt-6 text-center">
            <Link
              to="/escola/login"
              data-testid="forgot-back-login"
              className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-[#1e3a8a]"
            >
              <ArrowLeft className="w-3.5 h-3.5" />
              Voltar para o login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
